import { ReactElement, useEffect, useState } from 'react';
import MCPGuardDataSet from './MCPGuardDataSet';
import NoMCPGuard from './NoMCPGuard';
import { Box, CircularProgress } from '@mui/material';
import { GuardrailsService } from 'services/GuardrailsService';
import { Utils } from 'shared/helpers';

export interface MCPMetrics {
  activeServers: number;
  activeApiKeys: number;
  requests: number;
  blocked: number;
}

const MCPGuardTrail = (): ReactElement => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [mcpMetrics, setMcpMetrics] = useState<MCPMetrics | null>(null);

  const fetchMCPData = (): void => {
    setIsLoading(true);

    GuardrailsService.getMCPProxy()
      .then((res) => {
        const { data } = res.data;

        setMcpMetrics(data);
      })
      .catch((err) => {
        Utils.handleErrorResponse(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchMCPData();
  }, []);

  if (isLoading) {
    return (
      <Box className="empty-content">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <MCPGuardDataSet mcpMetrics={mcpMetrics} />
      <Box className="policy-audit-wrapper">
        <NoMCPGuard />
      </Box>
    </>
  );
};

export default MCPGuardTrail;
